import React from 'react'

import SectionEditor, { makeFrame } from 'tools/Nav/SectionEditor'

import paths from 'hub/paths'

import OrgActivitys from './ActivityLogs'
import { AssertActiveOrg } from './AssertActiveOrg'
import Billing from './Billing'
import List from './List'
import Members from './Members'
import Settings from './Settings'
import { LOAD_ORG, UPDATE_ORG } from './graphql'
import { OrgContext, OrgProvider, R_ORG } from './reducer'

export const SECTION = 'My Orgs'

const frame = makeFrame({
  routes: {
    orgs: {
      Component: List,
      label: SECTION
    },
    settings: {
      Component: Settings,
      label: 'Settings'
    },
    billing: {
      Component: Billing,
      label: 'Billing'
    },
    members: {
      Component: Members,
      label: 'Members'
    },
    activity: {
      Component: OrgActivitys,
      label: 'Activity'
    }
  },
  root: paths.public.org,
  section: SECTION,
  Default: List,
  Hook: AssertActiveOrg,

  // Show,
  Context: OrgContext,
  Provider: OrgProvider,
  actions: {
    LOAD: R_ORG.SET,
    RESET: R_ORG.RESET,
    MERGE: R_ORG.MERGE,
    DELETE: R_ORG.DELETE,
    SAVE: R_ORG.IGNORE
  },
  upsert: {
    mutation: UPDATE_ORG,
    queryName: 'orgChange'
    // DON'T ADD REFETCH QUERIES. this is causing the org settings page to reset which can cause some annoying problems when editing some fields such as Address.
  },
  load: {
    query: LOAD_ORG,
    queryName: 'orgs',
    component: 'results',
    list: true
  }
  // debug: "ORG"
})

export default function Org() {
  return <SectionEditor frame={frame} />
}
